import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { format } from "date-fns";

const axisStyle = { fill: "#71717a", fontSize: 10, fontFamily: "JetBrains Mono, monospace" };

function fmtTime(t) {
  try { return format(new Date(t), "HH:mm"); } catch { return t; }
}

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="panel px-3 py-2 text-xs font-mono-tech">
      <div className="label-tech mb-1">{format(new Date(label), "dd MMM · HH:mm")}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center gap-2">
          <span className="w-2 h-2" style={{ background: p.color }} />
          <span className="text-zinc-400">{p.name}</span>
          <span className="text-white ml-auto">{Number(p.value).toFixed(1)} kWh</span>
        </div>
      ))}
    </div>
  );
}

export default function EnergyChart({ data }) {
  return (
    <section className="panel p-5" data-testid="energy-chart">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base tracking-tight">ENERGY CONSUMPTION</h3>
          <div className="label-tech mt-1">kWh import / export / net</div>
        </div>
      </div>
      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%" minHeight={300}>
          <AreaChart data={data} margin={{ top: 5, right: 16, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="gImp" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#10b981" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gExp" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="Time" tickFormatter={fmtTime} tick={axisStyle} stroke="#3f3f46" />
            <YAxis tick={axisStyle} stroke="#3f3f46" />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 10, fontFamily: "JetBrains Mono, monospace", color: "#a1a1aa" }} />
            <Area type="monotone" dataKey="KWH_import" name="Import" stroke="#10b981" strokeWidth={1.5} fill="url(#gImp)" isAnimationActive={false} />
            <Area type="monotone" dataKey="KWH_export" name="Export" stroke="#3b82f6" strokeWidth={1.5} fill="url(#gExp)" isAnimationActive={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
